import React from 'react';

import { Vulnerabilities } from './index';

/** The flag-off page. It intentionally keeps Scan Analysis as its source. */
export const LegacyVulnerabilitiesPage = () => <Vulnerabilities />;
